import { IStreamData } from "@formant/core/model/IStreamData";
import { StreamType } from "@formant/core/model/StreamType";

import { IMetadataDataPoint } from "./IMetadataDataPoint";
import { pointsByDevice } from "./pointsByDevice";

export function currentByDevice<T extends StreamType>(
    datas: IStreamData<T>[],
    now: Date,
): IMetadataDataPoint<T>[] {
    return pointsByDevice(datas).map(({ deviceId, name, type, points }) => {
        const { tags, time, value } =
            points
                .slice()
                .reverse()
                .find(point => point.time.getTime() <= now.getTime()) ||
            points[0];
        return {
            deviceId,
            name,
            type,
            tags,
            time,
            value,
        };
    });
}
